import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, useTheme, Link } from '@mui/material'

const AccountDisabled = ({ setView, state, setState }) => {
  const theme = useTheme()
  const { t } = useTranslation('auth')

  return (
    <Box
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p={[3]}
      pt={6}
    >
      <Typography
        textAlign="center"
        style={{ color: theme.palette.error.dark }}
        mb={5}
        data-testid="accountDisabled-message"
      >
        {t('messageAccountDisabled', state)}
      </Typography>
      <Box mb={5} />
      <Box>
        <Link>
          <Typography
            variant="body2"
            color="primary"
            data-testid="accountDisabled-backToSignin"
            onClick={() => {
              setState((s) => ({ ...s, password: '', email: '' }))
              setView('signIn')
            }}
            sx={{ cursor: 'pointer' }}
          >
            <strong>{t('buttons.loginWithAnotherUser')}</strong>
          </Typography>
        </Link>
      </Box>
    </Box>
  )
}

export default AccountDisabled
